import React, { createContext, useState } from 'react';

export const LoginContext = createContext();

const SESSION_KEYS = [
    'hs_userData',
    'hs_userName',
    'hs_userId',
    'hs_isLoggedIn',
    'hs_otpPending',
    'hs_page',
    'hs_signup_form',
    'hs_signup_name',
    'hs_signup_otp',
    'hs_signup_userId',
    'hs_signup_loggedIn',
];

const readSession = (key, fallback) => {
    try {
        const value = sessionStorage.getItem(key);
        if (value === null) return fallback;
        return JSON.parse(value);
    } catch {
        return fallback;
    }
};

const writeSession = (key, value) => {
    try {
        if (value === null || value === undefined || value === '') {
            sessionStorage.removeItem(key);
        } else {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
    } catch {
        // ignore storage errors
    }
};

const clearAuthSession = () => {
    try {
        SESSION_KEYS.forEach((key) => sessionStorage.removeItem(key));
    } catch {
        // ignore storage errors
    }
};

export const LoginProvider = ({ children }) => {
    const [userData, setUserdataState] = useState(() => readSession('hs_userData', {}));
    const [userName, setUserNameState] = useState(() => readSession('hs_userName', null));
    const [userId, setUserIdState] = useState(() => readSession('hs_userId', null));
    const [isLoggedIn, setIsLoggedInState] = useState(() => readSession('hs_isLoggedIn', false));
    const [otpPending, setOtpPendingState] = useState(() => readSession('hs_otpPending', false));
    const [isPremium, setIsPremium] = useState(false);
    const [page, setPageState] = useState(() => readSession('hs_page', '/'));

    const setUserdata = (data) => {
        setUserdataState(data);
        writeSession('hs_userData', data);
    };

    const setUserName = (name) => {
        setUserNameState(name);
        writeSession('hs_userName', name);
    };

    const setUserId = (id) => {
        setUserIdState(id);
        writeSession('hs_userId', id);
    };

    const setIsLoggedIn = (value) => {
        setIsLoggedInState(value);
        writeSession('hs_isLoggedIn', value);
        if (value) {
            setOtpPendingState(false);
            writeSession('hs_otpPending', false);
        }
    };

    const setOtpPending = (value) => {
        setOtpPendingState(value);
        writeSession('hs_otpPending', value);
    };

    const setPage = (nextPage) => {
        setPageState(nextPage);
        writeSession('hs_page', nextPage);
    };

    const logout = () => {
        clearAuthSession();
        setUserdataState({});
        setUserNameState(null);
        setUserIdState(null);
        setIsLoggedInState(false);
        setOtpPendingState(false);
        setIsPremium(false);
        setPageState('/');
    };

    return (
        <LoginContext.Provider
            value={{
                userName,
                setUserName,
                userId,
                setUserId,
                userData,
                setUserdata,
                isLoggedIn,
                setIsLoggedIn,
                otpPending,
                setOtpPending,
                isPremium,
                setIsPremium,
                page,
                setPage,
                logout,
            }}
        >
            {children}
        </LoginContext.Provider>
    );
};
